const getMarginCorrectionAmount = (maybeANumber) =>
  typeof maybeANumber === "number" ? maybeANumber : 8;

export { getMarginCorrectionAmount };
